<template>
  <div class="order-list-page">
    <nav-header></nav-header>
    <section class="main sec-main">
      <div class="list-wrapper">
        <div class="head">
          <h2 class="title">工单池</h2>
          <ul class="tab-hd">
            <li v-for="item in tabs" :key="item.id" @click="tabChange(item.id)" :class="{'on':tabId==item.id}">
              {{item.name}}
              <span class="icon"></span>
            </li>
          </ul>
        </div>
        <div class="query">
          <div>服务天数 
            <i class="el-icon-caret-top" :class="(queryInfo.SortType === 2  && !queryInfo.IsDesc) ? 'hightLight': ''"  @click="sortQuery(false, 2)"></i>
            <i class="el-icon-caret-bottom" :class="(queryInfo.SortType === 2  && queryInfo.IsDesc) ? 'hightLight': ''" @click="sortQuery(true, 2)"></i> </div>
          <div>项目价格
            <i class="el-icon-caret-top" :class="(queryInfo.SortType === 3  && !queryInfo.IsDesc) ? 'hightLight': ''"  @click="sortQuery(false, 3)"></i>
            <i class="el-icon-caret-bottom" :class="(queryInfo.SortType === 3  && queryInfo.IsDesc) ? 'hightLight': ''"  @click="sortQuery(true, 3)"></i> </div>
          <div>发布时间
            <i class="el-icon-caret-top" :class="(queryInfo.SortType === 4  && !queryInfo.IsDesc) ? 'hightLight': ''"  @click="sortQuery(false, 4)"></i>
            <i class="el-icon-caret-bottom" :class="(queryInfo.SortType === 4  && queryInfo.IsDesc) ? 'hightLight': ''"  @click="sortQuery(true, 4)"></i> </div>
        </div>
        <ul class="order-list">
          <li class="list-item" v-for="(item,index) in orderList" :key="index" @click="toDetail(item)">
            <div class="line1">
              <div class="name">
                <img v-if="item.IsUrgent" style="vertical-align: middle;margin-top: -4px;margin-right:3px;" src="~@/assets/icon-urgent.png" alt="">
                <img v-if="item.IsJobPoolTop" style="vertical-align: middle;margin-top: -4px;margin-right: 6px;width: auto;height:16px;" src="~@/assets/icon-top.png" alt="">
                {{item.JobTitle }}
              </div>
              <span :class="['mark',{'mark1':item.JobType==1,'mark2':item.JobType==6&&item.IsProjectJob,'mark3':item.JobType==6&&!item.IsProjectJob}]"  >{{item.JobTypeStr}}</span>
              <span class="price" v-if="item.JobType == 6&&item.IsProjectJob==1">项目议价</span>
              <span class="price" v-else-if="item.Amount != '0.00'">￥{{item.Amount}}</span>
              <span class="price" v-else>￥{{item.MinAmount}}-{{item.MaxAmount}}</span>
            </div>
            <div class="line2">
              <i class="icon-local">
                <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2987"><path d="M474.129 65.929c-153.213 16.689-277.43 138.728-296.656 291.644-9.901 78.748 7.502 152.922 43.861 214.584 71.595 150.11 214.528 316.671 269.5 377.995 11.882 13.255 32.546 13.347 44.428 0.092 57.923-64.616 213.866-246.527 280.641-402.671 21.381-44.289 33.37-93.963 33.37-146.439-0.001-198.748-171.909-357.343-375.144-335.205z m67.511 504.399c-117.27 14.78-215.888-83.842-201.106-201.11 10.072-79.901 74.595-144.422 154.497-154.491 117.266-14.777 215.881 83.839 201.103 201.106-10.07 79.902-74.592 144.425-154.494 154.495z" p-id="2988"></path></svg>
              </i>
              <span class="city">{{item.Province}}·{{item.City}}</span>
              |
              <span class="distance">{{item.JobDistance}}km</span>
            </div>
            <div class="line3" v-if="item.ProductTrees.length">
              <span class="info">产品：{{item.ProductTrees[0].ProductDomainName}}-{{item.ProductTrees[0].ProductName}}-{{item.ProductTrees[0].BrandName}}-{{item.ProductTrees[0].SerialName}}</span>
              <span class="info">数量：{{item.ProductTrees[0].Count}}</span>
            </div>
            <div class="line4">
              <span class="label">上门时间：</span>
              <span class="time">{{item.ExecuteStartDtStr}} 至 {{item.ExecuteEndDtStr}}</span>
              <span class="ml50">{{item.CreateDateDiffer}}</span>
            </div>
            <div class="line4" v-if="item.JobType==1">
              <span class="label">预计服务天数：</span>
              <span class="time">{{item.ServiceDayCount}}天</span>
            </div>
          </li>
          <el-pagination  background layout="prev, pager, next" :curtrent-size="queryInfo.pageSize"  :page-size="queryInfo.pageSize" :current-page="queryInfo.pageNum" :total="queryInfo.total" @prev-click="currentChange" @next-click="currentChange" @current-change="currentChange"></el-pagination>
        </ul>
      </div>
      <aside class="aside">
        <h3 class="case-title">成功案例</h3>
        <el-carousel ref="carousel" height="270px" direction="vertical" :autoplay="false" indicator-position="none">
          <el-carousel-item v-for="(item,index) in caseList" :key="index">
            <div class="item-dl"  @click="$router.push({path:'/orderDetail',query:{jobId:item.JobId}})">
              <div class="item-dt">
                <span class="mark" v-if="item.ProductTrees.length">{{item.ProductTrees[0].ProductDomainName}}</span>
                <img class="pic" :src="item.SureTaskImgUrl" alt="">
              </div>
              <div class="item-dd">
                <div class="name">{{item.JobTitle}}</div>
                <div class="clear">
                  <i class="icon-local">
                    <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2987"><path d="M474.129 65.929c-153.213 16.689-277.43 138.728-296.656 291.644-9.901 78.748 7.502 152.922 43.861 214.584 71.595 150.11 214.528 316.671 269.5 377.995 11.882 13.255 32.546 13.347 44.428 0.092 57.923-64.616 213.866-246.527 280.641-402.671 21.381-44.289 33.37-93.963 33.37-146.439-0.001-198.748-171.909-357.343-375.144-335.205z m67.511 504.399c-117.27 14.78-215.888-83.842-201.106-201.11 10.072-79.901 74.595-144.422 154.497-154.491 117.266-14.777 215.881 83.839 201.103 201.106-10.07 79.902-74.592 144.425-154.494 154.495z" p-id="2988"></path></svg>
                  </i>
                  <span class="city">{{item.Province}}·{{item.City}}</span>
                  <div class="service" v-if="!item.IsProjectJob && item.JobType==6">标准服务</div>
                  <div class="service" v-if="item.IsProjectJob">项目服务</div>
                  <div class="service" v-if="item.JobType==1">自由服务</div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="btn-group">
          <i class="btn-icon el-icon-arrow-up" @click="prev"></i>
          <i class="btn-icon el-icon-arrow-down" @click="next"></i>
        </div>
        <div class="qrcode-box">
          <img src="@/assets/fixedRight/supaiweixin_ercode.jpg" alt="" class="qrcode">
          <div class="desc">扫码关注公众号</div>
          <div class="tel">
            客服电话：<i>021-60956592</i>
          </div>
        </div>
      </aside>
    </section>
    <gk-footer></gk-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import gkFooter from '@/components/footer.vue'
import {
  GetJobsInIndex,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
const BMap=window.BMap;
export default {
  components:{
    NavHeader,
    gkFooter,
  },
  data(){
    return{
      orderList:[],
      queryInfo: {
        SortType: 0,
        IsDesc: false,
        pageNum:1,
        pageSize:20,
        total:0,
      },

      loading:false,
      tabs:[{
        name:'B2B专区',
        id:1,
      },{
        name:'众包平台',
        id:2,
      }],
      tabId:1,
      lat:0,
      lng:0,
      caseList:[],
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  created() {
    this.getLocal();
    this.getCase();
  },
  mounted() {
  },
  methods: {
    //获取坐标
    getLocal(){
      let that=this;
      let geolocation = new BMap.Geolocation();
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function(r) {
          if (this.getStatus() == window.BMAP_STATUS_SUCCESS) {
            that.lat=r.point.lat;
            that.lng=r.point.lng;
          } else {
            console.log('failed' + this.getStatus());
          }
          that.loadData();
      });
    },
    //切换平台
    tabChange(id){
      this.tabId=id;
      this.queryInfo.pageNum=1;
      this.loading=false;
      this.orderList=[];
      this.loadData();
    },
    //加载数据
    loadData(){
      if(this.loading==true){
        return;
      }
      this.loading=true
      GetJobsInIndex({
        UserCode:this.userInfo?this.userInfo.UserCode : '',
        PageSize:this.queryInfo.pageSize,
        PageNo:this.queryInfo.pageNum,
        JobProgressType:this.tabId==1?3:2,
        TenderState:this.tabId==1?0:1,
        Lng:this.lng,
        Lat:this.lat,
        SortType: this.queryInfo.SortType,
        IsDesc: this.queryInfo.IsDesc,
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data.Lines ||[];
            this.orderList=list;
            this.queryInfo.total = r.Data.TotalRows
            //如果是第一页，页面滚动到首屏
            this.$nextTick(()=>{
              document.documentElement.scrollIntoView(true);
            })
            this.loading=false;
        }
      })
    },
    
    //去投标
    toDetail(item){
      if(item.JobType==1){
        this.$router.push({
          path:'/orderDetail',
          query:{
            jobId:item.JobId
          }
        })
      }else{
        this.$router.push({
          path:'/pickTenderInfo',
          query:{
            jobId:item.JobId
          }
        })
      }
    },
    //获取成功案例
    getCase(){
      GetJobsInIndex({
        UserCode:this.userInfo?this.userInfo.UserCode : '',
        PageSize:5,//显示5条成功案例
        PageNo:1,
        JobProgressType:1,
        TenderState:0,
        Lng:this.lng,
        Lat:this.lat,
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data.Lines ||[];
          this.caseList=list;
        }
      })
    },
    prev(){
      this.$refs.carousel.prev();
    },
    next(){
      this.$refs.carousel.next();
    },
    currentChange(page) {
      this.queryInfo.pageNum = page;
      this.loadData();
    },
    sortQuery(sort, type) {
      this.queryInfo.pageNum = 1;
      this.queryInfo[type] = sort;
      this.queryInfo.SortType = type || 0;
      this.queryInfo.IsDesc = sort;
      this.loadData();
    }
  },
  beforeRouteLeave (to, from, next) {
    next();
  }
}
</script>
<style lang="scss">
.order-list-page{
  padding-top:68px;
  .sec-main{
    min-height: 85vh;
    overflow: hidden;
    padding-top: 30px;
  }
  .list-wrapper{
    width: 850px;
    float: left;
    .head{
      padding-left: 20px;
      background-image: url('~@/assets/pickOrderImg/title-icon.png');
      background-repeat: no-repeat;
      background-position: left center;
      height: 30px;
      position: relative;
      &:after{
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #f75959;
        padding-left: 20px;
        background-clip: content-box;
        box-sizing: border-box;
      }
    }
    .query {
      display: flex;
      justify-content: end;
      padding: 10px 0;
      div {
        width: 100px;
        position: relative;
        i {
          position: absolute;
        }
        i.el-icon-caret-bottom {
          bottom: 0;
        }
        i.hightLight {
          color: #00b1e4;
        }
      }
    }
    .title{
      font-size: 18px;
      padding-left: 4px;
      line-height: 30px;
      color: #080808;
      float: left;
      font-weight: bold;
      font-style: italic;
    }
    .tab-hd{
      float: right;
      overflow: hidden;
      li{
        float: left;
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        position: relative;
        font-size: 14px;
        color: #f75959;
        cursor: pointer;
        text-align: center;
        margin-left: 10px;
        &.on{
          background-color: #f75959;
          color: #fff;
        }
        .icon{
          position: absolute;
          top: 0;
          z-index: 2;
          width: 0px;
          height: 0px;
          border-style: solid;
          border-width: 10px 5px 10px 5px;
          border-color: transparent;
        }
        &:first-child.on{
          .icon{
            border-left-color: #f75959;
            border-top-color: #f75959;
            left: 100%;
          }
        }
        &:last-child.on{
          .icon{
            right: 100%;
            border-right-color: #f75959;
            border-bottom-color: #f75959;
          }
        }
      }
    }
  }
  .list-item{
    background-color: #fff;
    border-bottom: 1px solid #e5e5e5;
    padding: 15px 0 5px;
    &:hover{
      background-color: #f9f9f9;
    }
    .line1{
      overflow: hidden;
      margin-bottom: 10px;
    }
    .name{
      float: left;
      font-size: 18px;
      font-weight: bold;
      color: #333;
      line-height: 30px;
    }
    .mark{
      float: left;
      display: block;
      margin-left: 10px;
      padding: 0 6px;
      height: 20px;
      line-height: 20px;
      margin-top: 5px;
      color: #fff;
      font-size: 12px;
      border-radius: 2px;
      &.mark1{
        background-color: #fd8f28;
      }
      &.mark2{
        background-color: #F75959;
      }
      &.mark3{
        background-color: #13B5B1;
      }
    }
    .price{
      float: right;
      font-size: 20px;
      color: #f75959;
      line-height: 30px;
      font-family: 'DIN-Regular';
      font-weight: bold;
    }
    .line2{
      font-size: 14px;
      color: #666;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .icon-local{
      color: #f75959;
      font-size: 18px;
    }
    .city{
      color: #333;
    }
    .distance{
      color: #666;
    }
    .line3{
      font-size: 14px;
      color: #666;
      line-height: 24px;
      margin-bottom: 10px;
      white-space: nowrap;
    }
    .info{
      margin-right: 30px;
      display: inline-block;
    }
    .line4{
      font-size: 14px;
      color: #666;
      line-height: 24px;
      white-space: nowrap;
      margin-bottom: 10px;
      .label{
        color: #999;
      }
      .ml50 {
        margin-left: 50px;
      }
    }
  }
  .el-pagination {
    text-align: right;
    margin-top: 30px;
  }
  .aside{
    float: right;
    width: 290px;
    .case-title{
      font-size: 18px;
      color: #333;
      line-height: 30px;
      margin-bottom: 20px;
      text-align: center;
      font-weight: bold;
      &:after,&:before{
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 60px;
        height: 1px;
        background-color: #f75959;
        margin: -3px 10px 0;
      }
    }
    .el-carousel{
      border: 1px solid #e5e5e5;
    }
    .btn-group{
      text-align: center;
      margin-top: 20px;
      .btn-icon{
        font-size: 36px;
        color: #e5e5e5;
        margin: 0 10px;
        &:hover{
          color: #ccc;
        }
      }
    }
  }
  .item-dl{
    padding: 10px;
    .item-dt{
      position: relative;
      width: 270px;
      height: 180px;
    }
    .pic{
      width: 100%;
      height: 100%;
      display: block;
      border: 0;
    }
    .mark{
      position: absolute;
      top: 0;
      left: 0;
      width: 56px;
      height: 16px;
      line-height: 16px;
      background-color: #f75959;
      font-size: 12px;
      color: #fff;
      text-align: center;
      z-index: 2;
      padding-left: 4px;
      &:after,&:before{
        content: "";
        position: absolute;
        left: 100%;
        width: 0px;
        height: 0px;
        border: 4px solid transparent;
      }
      &:before{
        top: 0;
        border-left-color: #f75959;
        border-top-color: #f75959;
      }
      &:after{
        bottom: 0;
        border-left-color: #f75959;
        border-bottom-color: #f75959;
      }
    }
    .item-dd{
      padding-top: 6px;
      cursor: pointer;
      .name{
        line-height: 24px;
        font-size: 14px;
        color: #333;
        font-weight: 600;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 6px;
      }
      .icon-local{
        float: left;
        font-size: 18px;
        color: #f75959;
      }
      .city{
        font-size: 14px;
        line-height: 20px;
        color: #666;
      }
      .service{
        float: right;
        font-size: 12px;
        line-height: 20px;
        padding: 0 10px;
        color: #fff;
        border-radius: 2px;
        background-color: #00b1e4 ;
      }
    }
  }
  .qrcode-box{
    text-align: center;
    margin-top: 20px;
    .qrcode{
      width: 130px;
      height: 130px;
      margin-bottom: 10px;
    }
    .desc{
      font-size: 14px;
      color: #333;
      line-height: 24px;
    }
    .tel{
      font-size: 18px;
      color: #333;
      line-height: 30px;
      i{
        color: #f75959;
      }
    }
  }
}
</style>